import React, { useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaRupeeSign,
} from "react-icons/fa";
import "./LocationDetails.css";
import { Link, useParams } from "react-router-dom";
import Header from "../Header";
import host from "../../config";
const KailasagiriLawn1 = () => {
  const { id } = useParams();
  const [ImagesList, setImagesList] = useState([]);
  console.log(useParams());
  useEffect(() => {
    if (!id) return; // Prevent running if ID is not available

    fetch(`${host}/get-booking-images-by-id`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }), // Correct JSON structure
    })
      .then((response) => response.json())
      .then((res) => {
        setImagesList(res);
        console.log("Fetched Images:", res);
      })
      .catch((error) => console.error("Error fetching images:", error));
  }, [id]); // Only depends on id

  // const images = [
  //   "/images/KAILASAGIRI  1.jpeg",
  //   "/images/KAILASAGIRI  2.jpeg",
  // ];

  const pricingData = [
    {
      id: 1,
      purpose:
        "Birthday Functions and other Official / Corporate meetings / Get-together functions (General Public)",
      rent: 50000,
      deposit: 10000,
      gst: 10800,
      cleaning: 10000,
      total: 80800,
    },
  ];

  return (
    <div>
      <Header />
      <div className="location-page">
        {/* Hero Section */}
        <div className="hero">
          <Carousel showThumbs={false} autoPlay interval={3000} infiniteLoop>
            {ImagesList.map((item, idx) => (
              <div key={idx} className="carousel-image">
                <img
                  src={item.url}
                  alt={`Kailasagiri Lawn-1 Image ${idx + 1}`}
                />
                <div className="overlay">
                  <h1>Kailasagiri Lawn-1</h1>
                  <p>Ideal Venue for Corporate and Social Functions</p>
                </div>
              </div>
            ))}
          </Carousel>
        </div>

        <div className="location-details">
          <h2>About the Venue</h2>
          <p className="line-height">
            <strong>Kailasagiri Lawn-1</strong> is a beautiful outdoor space
            located at the iconic Kailasagiri Hilltop in Visakhapatnam. It
            serves as a fantastic venue for hosting birthday functions,
            corporate meetings, and social gatherings. The lawn offers scenic
            views and spacious open areas, perfect for large events.
          </p>

          <h3>Key Amenities</h3>
          <ul className="amenities-list">
            <li>✅ Scenic Views of Kailasagiri Hill</li>
            <li>✅ Spacious Lawn for Large Gatherings</li>
            <li>✅ Modern Sound and Lighting Systems</li>
            <li>✅ Ample Parking Space</li>
            <li>✅ Clean and Well-Maintained Premises</li>
          </ul>

          <h3>📌 Venue Pricing Details</h3>
          <div className="pricing-container">
            {pricingData.map((item) => (
              <div key={item.id} className="pricing-card">
                <h4>{item.purpose}</h4>
                <p>
                  <FaRupeeSign /> Rent per Day:{" "}
                  <strong>{item.rent.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Security Deposit:{" "}
                  <strong>{item.deposit.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> GST (18%):{" "}
                  <strong>{item.gst.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Cleaning Charges:{" "}
                  <strong>{item.cleaning.toLocaleString()}</strong>
                </p>
                <p className="total">
                  <FaRupeeSign />{" "}
                  <strong>Total: {item.total.toLocaleString()}</strong>
                </p>
              </div>
            ))}
          </div>

          <p className="note">
            <strong>Note:</strong> Electrical charges as consumed will be paid
            by the applicant.
          </p>

          <h3>📞 Contact Information</h3>
          <div className="contact-info">
            <p>
              <FaMapMarkerAlt /> Location: Kailasagiri Hilltop, Visakhapatnam
            </p>
            <p>
              <FaPhoneAlt /> Phone: +91 87654 32109
            </p>
            <p>
              <FaEnvelope /> Email: info@kailasagirilawn.com
            </p>
          </div>

          {/* Book Now Button */}
          <Link to="/" className="book-now-btn">
            Book Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default KailasagiriLawn1;
